<template>
  <div class="table-tab__container" tabindex="1" style="overflow: auto; outline: none;">
    <table class="table-tab__block table" style="width: 1600px">
      <thead>
      <tr>
        <th colspan="7"></th>
        <template v-for="user in participants">
          <th :colspan="detailedViewMode[user.num] ? 2 + lot.criteria.expert.length + lot.criteria.lotPrice.length + 1 : 2" class="table-tab__color-border-left" >
            <p class="table-tab__color u-text-underline">{{user.name}}</p>
            <!--<router-link :to="{name: 'purchases-public-lot-alien-bid', params: { lotId: lot.id, requestId: request.num, bidId: bid.id, tab: 'bid'}}">-->
            <!--{{lot.catalog.name}} - {{request.num}} - {{bid.num}}-->
            <!--</router-link>-->
          </th>
          <th class="table-tab__color-border-right">
            <button class="gui-btn gui-btn--white-border gui-btn--w-127" @click.prevent="$set(detailedViewMode, user.num, !detailedViewMode[user.num])">
              {{detailedViewMode[user.num] ? 'Свернуть': 'Подробнее'}}
            </button>
          </th>
        </template>
      </tr>
      </thead>
      <thead class="table-tab__thead">
      <tr class="table-tab__tr">
        <th class="table-tab__th--row table-tab__border-right">№</th>
        <th>Наименование</th>
        <!--<th>Производитель</th>-->
        <th>Кол-во</th>
        <th>Ед. изм</th>
        <th>Цена за единицу</th>
        <th>Сумма</th>
        <th>Лучшее предложение <br> (Итоговая оценка)</th>
        <!--<th>Итоговая оценка по <br> экспертнооцениваемым <br> критериям</th>-->

        <template v-for="user in participants">
          <th class="table-tab__color-border-left">Рейтинг</th>

          <template v-if="detailedViewMode[user.num]">
            <th v-for="c in lot.criteria.expert">{{c.criterionName}}</th>
            <th v-for="c in lot.criteria.lotPrice">Оценка приведенной стоимости</th>
            <th>Итоговая оценка</th>
          </template>

          <th>Приведенная цена</th>
          <th class="table-tab__color-border-right"
              v-for="c in lot.criteria.lotPrice">Цена</th>
        </template>
      </tr>
      </thead>
      <tbody class="table-tab__tbody">
      <tr v-for="(row, rowId) in specs">
        <th class="table-tab__th--row table-tab__border-right">
          {{rowId + 1}}
        </th>
        <td>{{row.catalog.name}}</td>
        <!--<td>{{row.vendor}}</td>-->
        <td>{{row.count}}</td>
        <td>{{row.okeiName}}</td>
        <td>{{row.price | price}}</td>
        <td>{{row.price * row.count | price}}</td>
          <td>{{getBestEstimation(row.position) | finalEstimation}}</td>
        <!--<td>-&#45;&#45;</td>-->

        <template v-for="user in participants">
          <td class="table-tab__color-border-left">{{getBestBid(user, row.position).rank}}</td>

          <template v-if="detailedViewMode[user.num]">
            <th v-for="c in lot.criteria.expert">{{getCriteriaEstimate(user,  row.position, c) | estimation}}</th>
            <th v-for="c in lot.criteria.lotPrice">{{getSpecPosition(user,  row.position, c).presentPriceEstimate | estimation}}</th>
            <th>{{getSpecPosition(user, row.position).estimate | finalEstimation}}</th>
          </template>

          <td>{{getSpecPosition(user, row.position).presentPrice | present-price}}</td>
          <td class="table-tab__color-border-right"
              v-for="c in lot.criteria.lotPrice">
            <p class=" table-tab__tr-w-70"
               :class="{'table-tab__color-information': getCriteriaValue(user, row.position, c) == minCriteriaValue(row.position, c)}">
              {{getCriteriaValue(user, row.position, c) | price}}
            </p>
          </td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      // report: {
      //   type: Object,
      //   required: true
      // }
    },

    data: () => ({
      detailedViewMode: {}
    }),

    computed: {
      specs() {
        return this.lot.specs;
      },

      participants() {
        return this.requests;
      },

      requests() {
        return this.lot.requests.filter(r => r.state.APPROVED || r.state.CONDITIONALLY_APPROVED);
      }
    },

    methods: {
      getBestBid(request, position) {
        let summaries = _.filter(this.lot.requestsTotal.summary, { position });
        summaries = _.orderBy(summaries, 'estimate', 'desc');

        const idx = _.findIndex(summaries, {
          requestId: request.num,
          position
        });

        if (idx === -1) return {};

        const bid = _.find(request.bids, { id: summaries[idx].bid });

        const data = _.get(_.find(this.lot.requestsTotal.data, { request: request.num}), 'specs');
        const spec = _.find(data, { bid: bid.id, position})

        return {
          ...bid,
          rank: idx + 1,
          positionEstimate: summaries[idx].estimate,
          positionPresentPriceEstimate: summaries[idx].presentPriceEstim / 10,
          positionPresentPrice: _.get(spec, 'presentPrice')
        }
      },

      getBestEstimation(position) {
        let summaries = _.filter(this.lot.requestsTotal.summary, { position });
        summaries = _.orderBy(summaries, 'estimate', 'desc');

        return _.get(summaries, '[0].estimate');
      },

      getSpecPosition(request, position) {
        const bid = this.getBestBid(request, position);

        return {
          ..._.find(bid.specs, { position }),
          estimate: bid.positionEstimate,
          presentPrice: bid.positionPresentPrice,
          presentPriceEstimate: bid.positionPresentPriceEstimate
        }
      },

      getCriteriaEstimate(request, position, criteria) {
        const requestSummary = _.find(this.lot.requestsTotal.data, { request: request.num });
        const criteriaSummary = _.get(requestSummary, 'criterions');

        const bid = this.getBestBid(request, position);
        let summary = _.find(criteriaSummary, {
          bidNum: bid.num,
          position,
          num: criteria.num
        });

        if (!summary) {
          summary = _.find(criteriaSummary, {
            bidNum: bid.num,
            position: 0,
            num: criteria.num
          });
        }

        return _.get(summary, 'estimate')
      },

      getCriteriaValue(request, position, criteria) {
        const requestSummary = _.find(this.lot.requestsTotal.data, { request: request.num });
        const criteriaSummary = _.get(requestSummary, 'criterions');

        const bid = this.getBestBid(request, position);
        let summary = _.find(criteriaSummary, {
          bidNum: bid.num,
          position,
          num: criteria.num
        });

        if (!summary) {
          summary = _.find(criteriaSummary, {
            bidNum: bid.num,
            position: 0,
            num: criteria.num
          });
        }

        return _.get(summary, 'value')
      },

      minCriteriaValue(position, criteria) {
        const min = _.min(this.lot.requestsTotal.data.map(r => {
          const prices = _.filter(_.get(r, 'criterions'), { num: criteria.num }).map(e => e.value);
          return _.min(_.compact(prices).map(e => +e));
        }));

        return min;
      }
    }
  }
</script>

<style scoped>

</style>
